module.exports = __webpack_public_path__ + "img/bibibi-w.dbef952e.svg";